// Shared breakpoints and slidesToShow for CategoryRail
// Denser layout: portrait (2:3) cards are smaller so each rail shows more.
// regular === poster (every card is a portrait poster now); topvideo (the
// top-number rails) stays one lower since the rank number eats width.
export const RAIL_BREAKPOINTS = [
  { breakpoint: 1921, regular: 7, poster: 7, topvideo: 6, posterWidth: 160 },
  { breakpoint: 1920, regular: 7, poster: 7, topvideo: 6, posterWidth: 150 },
  { breakpoint: 1366, regular: 6, poster: 6, topvideo: 5, posterWidth: 140 },
  { breakpoint: 1280, regular: 6, poster: 6, topvideo: 5, posterWidth: 140 },
  { breakpoint: 1024, regular: 4, poster: 4, topvideo: 4, posterWidth: 130 },
  { breakpoint: 768, regular: 3, poster: 3, topvideo: 3, posterWidth: 110 },
  { breakpoint: 0, regular: 2, poster: 2, topvideo: 2, posterWidth: 100 },
];

// Helper to get slidesToShow for a given width and rail style.
// react-slick's `responsive` applies each entry as a max-width breakpoint (the
// settings for breakpoint B are used when viewport <= B), picking the smallest
// matching breakpoint. This helper MUST use the same semantics so the top-level
// slidesToShow and the responsive array agree — otherwise a laptop width lands
// on a different entry than react-slick and the rail shows the wrong count.
export function getSlidesToShow(width, style = 'regular') {
  const sorted = [...RAIL_BREAKPOINTS].sort((a, b) => a.breakpoint - b.breakpoint);
  for (const bp of sorted) {
    if (width <= bp.breakpoint) {return bp[style] ?? bp.regular;}
  }
  // Wider than the largest breakpoint: use the largest entry.
  const largest = sorted[sorted.length - 1];
  return largest[style] ?? largest.regular;
}

// Helper to get adaptive slidesToShow based on actual content count
export function getAdaptiveSlidesToShow(width, style = 'regular', contentCount = 0) {
  const maxSlides = getSlidesToShow(width, style);

  // If we have fewer items than max slides, adjust to prevent duplication
  if (contentCount > 0 && contentCount < maxSlides) {
    return Math.min(contentCount, maxSlides);
  }

  return maxSlides;
}

export function getPosterSize(width) {
  for (const bp of RAIL_BREAKPOINTS) {
    if (width < bp.breakpoint) {continue;}
    const posterWidth = bp.posterWidth;
    return {
      width: posterWidth,
      height: Math.round((posterWidth * 3) / 2),
    };
  }
  return { width: 100, height: Math.round((100 * 3) / 2) };
}
